import React from 'react'
import { Link } from 'react-router-dom'

export function ShowcaseViewAllArtistsLink() {
  return (
    <p className="mt-12 md:mt-16 font-mono text-[10px] uppercase tracking-widest text-black/40 cursor-default">
      <Link to="/showcase" className="hover:text-black/70 transition-colors">
        View all artists
      </Link>
    </p>
  )
}
